(function ($) {
  $(document).ready(function(){


    // if ( $("input#measure_unit").val() == 'inch' ){
    //   if( $('input[name="width-ft[]"]').length == 0 || $('input[name="width-ft"]').length == 1){
    //     $('input[name="width-ft"]').parent().find($('#removeRow')).hide();
    //   }
    //   else{
    //     $('input[name="width-ft"]').parent().find($('#removeRow')).show();
    //   }
    // }
    // else{
    //   if( $('input[name="width-cm[]"]').length == 0 || $('input[name="width-cm"]').length == 1){
    //     $('input[name="width-cm"]').parent().find($('#removeRow')).hide();
    //   }
    //   else{
    //     $('input[name="width-cm"]').parent().find($('#removeRow')).show();
    //   }
    // }
    
    // Add additional width input field
    $("#addRow").on('click', function () {
      var fieldHtml = '', newFieldRow = '';
      fieldHtml += '<div id="inputFormRow">';
      fieldHtml += '<div class="input-group mb-3">';
      
      if ( $("input#measure_unit").val() == 'inch' ){
        newFieldRow = $('#newRowIN');
        $('input[name="width-ft"]').attr('name','width-ft[]');
        $('input[name="width-in"]').attr('name','width-in[]');
        fieldHtml += '<input type="number" name="width-ft[]" class="form-control m-input ft-width" placeholder="ft" autocomplete="off">';
        fieldHtml += '<input type="number" name="width-in[]" class="form-control m-input in-width" placeholder="in" autocomplete="off">';
      }
      else{
        newFieldRow = $('#newRowCM');
        $('input[name="width-cm"]').attr('name','width-cm[]');
        fieldHtml += '<input type="number" name="width-cm[]" class="form-control m-input cm-width" placeholder="cm" autocomplete="off">';
      }
      
      
      fieldHtml += '<div class="input-group-append">';
      fieldHtml += '<button id="removeRow" type="button" class="btn btn-danger">Remove</button>';
      fieldHtml += '</div>';
      fieldHtml += '</div>';
      $(newFieldRow).append(fieldHtml);
      
      // $( ".in-width" ).on( 'change', function() {
      //     var max = parseInt($(this).attr('max'));
      //     if ($(this).val() > max) {
      //         $(this).val(max);
      //     }     
      // }); 
    });

    // Remove width input field.
    // Defer the DOM removal: the document-level backdrop handler in main-product.liquid
    // closes the drawer when the click target isn't inside .modal-calculator-form.
    // Removing the row synchronously detaches the button mid-click, so that check
    // misfires and closes the calc. Removing on the next tick keeps the button attached
    // through the whole click dispatch, then cleans up.
    $(document).on('click', '#removeRow', function (e) {
        e.stopPropagation();
        var group = $(this).closest('.input-group')[0];
        setTimeout(function () {
          group.remove();
          if ( $("input#measure_unit").val() == 'inch' ){
            if( $('input[name="width-ft[]"]').length < 2){
              $('input[name="width-ft[]"]').attr('name','width-ft');
              $('input[name="width-in[]"]').attr('name','width-in');
            }
          }
          else{
            if( $('input[name="width-cm[]"]').length < 2){
              $('input[name="width-cm[]"]').attr('name','width-cm');
            }
          }
        }, 0);
    });

    // Inch to CM toggle
    $('button.switcher').on('click',function() {
        $(this).toggleClass('centimeter').find('span').toggle();
        $('#inputFormRow.feetinch').toggle();
        $('#inputFormRow.centimeter').toggle();
        $('#newRowIN').toggle();
        $('#newRowCM').toggle();
        var hiddenField = $('#measure_unit'),
        val = hiddenField.val();
        hiddenField.val(val === "inch" ? "cm" : "inch");
    });

    // "How to measure your wall?" — reveal/hide the (optional) measure panel.
    // Panel starts display:none, so refresh the owl carousel once it becomes visible
    // or it initialises at 0 width and the slides render broken.
    $(document).on('click', '.measure-toggle', function () {
        // Explicit open/close (rather than toggleClass) so the panel can play a
        // short exit animation: `measure-closing` keeps it displayed while it
        // fades out, and drops off once that finishes.
        var $content = $('.productDrawerContent');
        var open = !$content.hasClass('measure-open');
        if (open) {
            $content.removeClass('measure-closing').addClass('measure-open');
        } else {
            $content.removeClass('measure-open').addClass('measure-closing');
            clearTimeout(window.__measureCloseTimer);
            window.__measureCloseTimer = setTimeout(function () {
                $content.removeClass('measure-closing');
            }, 240);
        }
        $(this).attr('aria-expanded', open);
        if (open) {
            // The carousel was initialised while this panel was display:none, so its
            // slide widths were measured against a zero-width stage. A single delayed
            // refresh is a race — it sometimes fired before layout settled, which is
            // why the diagrams occasionally opened over/under-sized and overlapping.
            // Refresh after layout has actually happened, then again as it settles.
            var $sider = $('#calculator-sider');
            function refreshSider() { $sider.trigger('refresh.owl.carousel'); }
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    refreshSider();
                    setTimeout(refreshSider, 150);
                    setTimeout(refreshSider, 450);
                });
            });
            // and keep it correct through any later reflow (fonts, images, rotation)
            if (!window.__calcSiderRO && window.ResizeObserver) {
                var host = document.querySelector('.modal-details');
                if (host) {
                    var t;
                    window.__calcSiderRO = new ResizeObserver(function () {
                        clearTimeout(t);
                        t = setTimeout(refreshSider, 120);
                    });
                    window.__calcSiderRO.observe(host);
                }
            }
            // mobile: panel stacks below the calc (off-screen) — scroll the drawer down to reveal it
            if (window.matchMedia('(max-width:768px)').matches) {
                setTimeout(function () {
                    var dr = document.querySelector('.productDrawer');
                    var d = document.querySelector('.modal-details');
                    if (dr && d) {
                        dr.scrollTo({ top: dr.scrollTop + d.getBoundingClientRect().top - 20, behavior: 'smooth' });
                    }
                }, 140);
            }
        }
    });

    // In/cm pill — press anywhere on the pill flips the unit, then syncs active state
    $(document).on('click', '.calc-unit-toggle', function () {
        $('button.switcher').trigger('click');
        var u = $('#measure_unit').val();
        $('.calc-unit-toggle .unit-opt').removeClass('active');
        $('.calc-unit-toggle .unit-opt[data-unit="' + u + '"]').addClass('active');
    });

    // Set number value to MAX if entered greater than MAX
    $( ".in-height, .in-width" ).on( 'change', function() {
        var max = parseInt($(this).attr('max'));
        if ($(this).val() > max) {
            $(this).val(max);
        }     
    }); 
    
    // Radio buttons for CM & Inch
    // var radioButtons = document.querySelectorAll('input[name="switcher"]');
    
    // function toggleCheck() {
    //     radioButtons.forEach(function(radioButton){
    //         radioButton.classList.toggle('checked');
    //         radioButton.classList.contains('checked') ? radioButton.checked = true : radioButton.checked = false;
    //     });
    // }
    
    // radioButtons.forEach(function(radioButton){
    //     radioButton.addEventListener('click',toggleCheck,false);
    // });
    
  });

  

  
  
  
})(jQuery);